module.exports = __webpack_public_path__ + "img/time-range.6db66987.svg";